
/**
 * CsvMaker inspired by
 * https://medium.com/@idorenyinudoh10/how-to-export-data-from-javascript-to-a-csv-file-955bdfc394a9
 */
export class CsvMaker {
    _separator = ","
    _lineBreak = "\n"
    _objUrl = null

    constructor(separator = ",", lineBreak = "\n") {
        this._separator = separator
        this._lineBreak = lineBreak
    }

    /**
     * Parse json object like:
     * 
     * [
     *   {
     *     firstName: 'Idorenyin',
     *     lastName: 'Udoh'
     *   },
     *   {
     *     firstName: 'Loyle',
     *     lastName: 'Carner'
     *   },
     *   {
     *     firstName: 'Tamunotekena',
     *     lastName: 'Dagogo'
     *   },
     * ] 
     *  
     * in a text/csv blob where first line was composed by the object keys
     * 
     * firstName,    lastName
     * --------------------
     * Idorenyin,    Udoh
     * Loyle,        Carner
     * Tamunotekena, Dagogo
     * 
     * @param {object} data - Json object to parse
     * @param {boolean} keyAsTitle - flag, if TRUE parser set object keys as first CSV line
     */
    parseJsonData(data, keyAsTitle = true) {
        const refinedData = []

        if(keyAsTitle) {
            const titleKeys = Object.keys(data[0])
            refinedData.push(titleKeys)
        }
        data.forEach(item => {
            refinedData.push(Object.values(item))  
        })

        let csvContent = ''
        refinedData.forEach(row => {
            csvContent += row.join(this._separator) + this._lineBreak
        })

        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8,' })
        this._objUrl = URL.createObjectURL(blob)

        return this;
    }

    /**
     * Create virtual hidden link to start downlad of a CSV file with parsed data 
     * @param {string} filename 
     */
    downlad(filename = "download.csv") {
        let link = document.createElement('a')
        link.setAttribute('href', this._objUrl)
        link.setAttribute('download', filename)
        link.textContent = 'Click to Download '+filename

        document.querySelector('body').append(link)
        link.click()
    }
}